export default {
  deforestation: {
    privacyEnabled:"Privacidade Habilitada",
    geolocationPrivacySubHeading: "Alterne para controlar a confidencialidade dos dados de localização. Ligue para marcar a localização como confidencial e restringir sua visibilidade. Desligue para tornar a localização publicamente acessível.",
    geolocationPrivacy:"Privacidade de Geolocalização",

    failedEudrReportDueSetting:"Por favor, certifique-se de que as configurações das seguintes propriedades estejam corretamente configuradas: Expiração do Relatório, Massa Líquida, Volume e Raio.",
    producerData:{
      addProducers:"ADICIONAR NOVO PRODUTOR",
      countryInfo: "Campo para inserir ou exibir o país associado a um produtor."
    },
    selectFileToUpload: "Selecione o arquivo para enviar dados",
    totalGeofenceAreaHA: "Área total do Polígono (ha)",
      submissionDate: "Data de Submissão",
      eudrReferenceNo: "Nº de Referência EUDR",
      internalReferenceNo: "Nº de Referência Interna",
      exporter: "Exportador",
      exporterInfo: "Nome do exportador. A entidade ou parte responsável pela exportação dos bens.",
      importer: "Importador",
      importerInfo: "Nome do importador. A entidade ou parte responsável pela importação dos bens.",
      shipmentReferenceNo: "Nº de Referência do Envio",
      shipmentReferenceNoInfo: "Um identificador único usado para referenciar a remessa.",
      ownerShipType: "Tipo de Propriedade",
      ownerShipTypeInfo: "O tipo de propriedade associada à remessa.",
      buyer: "Comprador",
      port_of_origin: "Porto de Origem",
      port_of_origin_info: "A localização onde a remessa se origina.",
      port_of_destination: "Porto de Destino",
      port_of_destination_info: "O porto de destino previsto para a remessa.",
      no_of_stops: "Nº de Paradas",
      shipping_line: "Linha de Navegação",
      shipping_line_info: "A empresa ou entidade responsável pelo transporte da remessa.",
      expected_arrival_date: "Data de Chegada Prevista",
      expected_arrival_date_info: "Data prevista de chegada da remessa ao destino.",
      container_id: "ID do Contêiner",
      container_id_info: "Identificador único para el contenedor de envío utilizado en el envío.",
      container_type: "Tipo de Contêiner",
      container_type_info: "O tipo ou categoria de contêiner de envio.",
      container_size: "Tamanho do Contêiner (ft)",
      container_size_info: "As dimensões físicas do contêiner de envio.",
      container_capacity: "Capacidade do Contêiner (Toneladas)",
      container_capacity_info: "A carga máxima ou capacidade do contêiner de envio.",
      eudr_reference_number: "Nº de Referência EUDR",
      veryLowProbability: "Probabilidade Muito Baixa de Desmatamento",
      lowProbability: "Probabilidade Baixa de Desmatamento",
      mediumProbability: "Probabilidade Média de Desmatamento",
      highProbability: "Probabilidade Alta de Desmatamento",
      veryHighProbability: "Probabilidade Muito Alta de Desmatamento",
      locationName: "Nome do local",
      zeroOrNegligibleProbability: "Probabilidade de desmatamento zero/insignificante",
      oneForAllFarms:"Um para Todas as Fazendas",
      oneForEachFarm:"Um para Cada Fazenda",
      approve: "Aprovar",
      conclude:"Concluir",
      approveMessage: "Tem certeza de que deseja aprovar este relatório? Ao aprovar este relatório, ele será permanentemente carregado na blockchain. Um link de blockchain e um código QR serão gerados, e nenhuma atualização ou edição poderá ser feita. Deseja continuar?",
      print: "Imprimir",
      uploadExistingAssessment:"Carregar Avaliação Existente",
      completeDimitraAssessment:"Avaliação pelo Operador ou Fornecedor",
      assessmentByFarmer: "Avaliação pelo Agricultor",
      uploadedToEU: "Carregado no Portal da UE",
      pending: "Pendente",
      underReview: "Em revisão",
      compliant: "Conforme",
      nonCompliant: "Não Conforme",
      analyzeDeforestation: "Analisando Desmatamento",
      readyToProceed: "Pronto para Prosseguir",
      processingFarm: "Processando fazenda",
      mitigationRequired: "Mitigação necessária",
  
      veryHighDeforestationProbability: "Probabilidade de desmatamento muito alta",
      highDeforestationProbability: "Probabilidade de desmatamento alta",
      mediumDeforestationProbability: "Probabilidade de desmatamento média",
      lowDeforestationProbability: "Probabilidade de desmatamento baixa",
      veryLowDeforestationProbability: "Probabilidade de desmatamento muito baixa",
      zeroNegligibleDeforestationProbability: "Probabilidade de desmatamento zero/negligível",
      manuallyMitigated: "Mitigado manualmente",
  
      selectCountry: "Selecionar País", 
      internalReferenceNumberMustBeAlphanumeric: "O número de referência interna deve ser alfanumérico",
      atLeastOneOfSupplierIdOrSupplierNameIsRequired: "Pelo menos um dos campos ID do fornecedor ou Nome do fornecedor é obrigatório",
      atLeastOneOfOperatorIdOrOperatorNameIsRequired: "Pelo menos um dos campos ID do operador ou Nome do operador é obrigatório",
      netMassIsRequired: "A massa líquida é obrigatória",
      netMassMustBeValid: "A massa líquida deve ser válida",
      thisFieldIsRequired: "Este campo é obrigatório",
      volumeMustBeNumeric: "O volume deve ser numérico",
      nameIsRequired: "O nome é obrigatório",
      countryIsRequired: "O país é obrigatório",
    
      confirmPdfDownload: "Deseja baixar todos os anexos em formato PDF?", 
      confirmJsonDownload: "Deseja baixar todos os anexos em formato JSON?",
      basicFinalFarmListWithStatus: "Lista básica de fazendas finais com status",
      detailedInformationIncludingDescriptionOfRiskMitigationActivities: "Informações detalhadas, incluindo a descrição das atividades de mitigação de riscos",
      completeDocumentIncludingRiskMitigationAndAttachedDocuments: "Documento completo, incluindo mitigação de riscos e documentos anexos",
      
      existing: "Existente",
      survey: "Pesquisa",
    
      operatorInformation: "Informações do Operador", 
      addNewOperator: "Adicionar Novo Operador", 
    
      reportAddedSuccessfully: "Relatório adicionado com sucesso",
      reportUpdatedSuccessfully: "Relatório atualizado com sucesso",
      itemDeletedSuccessfully: "Item excluído com sucesso",
      reportDeletedSuccessfully: "Relatório excluído com sucesso",
      anErrorOccurredWhileDeletingTheReport: "Ocorreu um erro ao excluir o relatório",
    
      valueMustBeBetween02And40: "O valor deve estar entre 0,2 e 40",
    
      EUDRDeforestationStatusTT: "Seleção do status de desmatamento. Alta Probabilidade de Desmatamento: Uma categoria específica de avaliação de risco atribuída a determinadas áreas geográficas com base na probabilidade de desmatamento ou degradação florestal. Ajuda a determinar os requisitos de due diligence para operadores que colocam no mercado da UE produtos básicos relevantes (como cacau, café, etc.) ou produtos que os contêm ou são fabricados com eles. Baixa Probabilidade de Desmatamento: Uma categoria de avaliação de risco atribuída a áreas geográficas que são consideradas com baixa probabilidade de sofrer desmatamento ou degradação florestal significativa. Esta designação influencia os requisitos de due diligence para operadores que colocam no mercado da UE produtos ou commodities provenientes dessas áreas. Probabilidade de Desmatamento Nula/Insignificante: Uma probabilidade muito baixa ou inexistente de que ocorra desmatamento. Implica que o risco ou impacto do desmatamento é considerado extremamente pequeno ou insignificante.",
    
      complianceRiskWarnings: "Avisos de Risco de Conformidade",
      complianceRiskWarningsInfo: "Exibe o título da seção, indicando que esta área foca em avisos relacionados aos riscos de conformidade no processo de due diligence.",
      locationVerificationTT: "Refere-se ao processo de confirmar e validar a localização geográfica dos locais de produção como parte dos procedimentos de due diligence. Envolve garantir que os detalhes da localização fornecidos, como coordenadas ou endereço, representem com precisão o local físico onde ocorrem as atividades de produção. Esta verificação é crucial para avaliar os impactos ambientais, a conformidade com o uso da terra e a precisão dos dados relatados no relatório de due diligence.", 
      netMassKg: "Massa Líquida (kg)",
      volumeM3: "Volume (m3)",
      volumeM: "Volume",
      warning: "Aviso",
    
      productionPlacesTT: "Locais onde bens são fabricados ou cultivados.",
      productionPlacesCountryInfo: "Um corpo territorial distinto com seu próprio governo e fronteiras.",
      productionPlacesProducersInfo: "Entidade responsável por criar ou cultivar bens.",
      totalsTT: "A seção 'Totais' fornece um resumo dos principais indicadores quantitativos para todo o conjunto de dados ou relatório. Agrega dados para oferecer aos usuários uma visão rápida das métricas gerais, como a massa total do produto, o volume total do produto, a área do local de produção, etc., envolvidas no relatório de due diligence.",
    
      AnalysisOfDeforestationStatusTT: "A análise do status atual do desmatamento dentro de uma área específica, geralmente realizada para avaliar o impacto ambiental ou a conformidade com os esforços de conservação.",
    
      complete: "Completo",
    
      undoDelete: "Desfazer Exclusão",
  
      verifyingLocationsData: 'Verificando dados de localização...',
      crossCheckingWithProductionPlaces: 'Verificando com locais de produção...',
      almostTherePleaseHoldOn: 'Quase lá, por favor aguarde...',
      LocationVerifiedSuccessfully: 'Localização(ões) verificada(s) com sucesso!',
      allProductionPlacesAndLocationsHaveBeenConfirmed: 'Todos os locais de produção e localizações foram confirmados!',
      errorCheckingOverlaps: 'Erro ao verificar sobreposições.',
      farmIsBiggerThan4HectaresItNeedsToBeAPolygon: 'A fazenda tem mais de 4 hectares, precisa ser um polígono',
      failedToFetchSettings: 'Não foi possível obter as configurações. Por favor, verifique suas configurações ou entre em contato com o suporte se o problema persistir.',
      farmCountryNotDefined: 'País da fazenda não definido.',
      theGeofencesSupposeToBeIn: 'A geocerca deveria estar em',
      butItsIn: 'mas está em',
      geofenceIsInOcean: 'A geocerca ou parte dela está no oceano.',
  
      existingReport: "Relatório de Desmatamento Existente",
      dimitraReport: "Relatório de Desmatamento Dimitra",

      anErrorOccuredWhileFetchingTheDeforestationReport: "Ocorreu um erro ao buscar o relatório de desmatamento.",
      
    
      attachRiskMigrationDocTT: "Indica a ação de associar ou vincular um único documento a todas as fazendas identificadas com risco de desmatamento, geralmente para fins de documentação ou conformidade.",
    
  
      edurDueDeligenceStatus: "Status de Devida Diligência do EUDR",
      deforestationComplianceReport: "Relatórios de Conformidade com o Desmatamento",
      noDeforestationComplianceReport: "Nenhum Relatório de Conformidade com o Desmatamento Encontrado",
      loadingDeforestationComplianceReport: "Carregando Relatório de Conformidade com o Desmatamento",
      farmName: "Nome da Fazenda",
      farmRegistrationId: "ID de Registro da Fazenda",
      farmerName: "Nome do Agricultor",
      farmerRegistrationId: "ID de Registro do Agricultor",
      uniqueFarmerId: "ID Único do Agricultor",
      uniqueFarmId: "ID Único da Fazenda",
      farmLocation: "Localização da Fazenda",
      area: "Área",
      farmAddress: "Endereço da Fazenda",
      dateOfRequest: "Data da Solicitação",
      status: "Status",
      settings: "Configurações",
  
      farmLatitude: "Latitude da Fazenda",
      farmLongitude: "Longitude da Fazenda",
      shareQRCode: "Compartilhar Código QR",
      copy: "Copiar",
  
      allCountries: "Todos os Países",
      allRegions: "Todas as Regiões",
      allFarms: "Todas as Fazendas",
      allProducer: "Todos os Produtores",
      viewCertificate: "Ver Certificado",
  
      assignmentIssued: "Atribuição Emitida",
  
      complianceCertification: "Certificação de Conformidade",
      noComplianceCertification: "Nenhuma Certificação de Conformidade Encontrada",
      loadingComplianceCertification: "Carregando Certificação de Conformidade",
  
      eudrForestAssessment: "Avaliações Florestais EUDR",
      assessmentReport: "Relatório de Avaliação",
      downloadPDF: "Baixar PDF",
      back: "Voltar",
      farmDetails: "Detalhes da Fazenda",
  
      dimitraFarmId: "ID da Fazenda Dimitra",
      dimitraFermerId: "ID do Agricultor Dimitra",
  
      forestLossHA: "Perda de Floresta (ha)",
      forestGainHA: "Ganho de Floresta (ha)",
      forestUnchangedHA: "Floresta Inalterada (ha)",
      shareCertificate: "Compartilhar Certificado",
      forestUnchanged: "Floresta Inalterada",
      forestLoss: "Perda de Floresta",
      forestGain: "Ganho de Floresta",
      totalGeofenceArea: "Área total do Polígono",
      deforestationProbability: "Probabilidade de Desmatamento",
      colorCode: "Código de Cores",
      geofenceArea: "Área Afetada",
      percentageOfGeofenceArea: "Porcentagem de Área Afetada",
      view: "Visualizar",
      customization: "Personalização",
      recordsPerpage: "Registros por Página",
      restoreDefault: "Restaurar Padrão",
      apply: "Aplicar",
      forestAssessmentHelp: "Se tiver dúvidas sobre este relatório ou precisar de ajuda para entendê-lo, entre em contato conosco através do Help Desk.",
      overallDeforestationProbability: "Probabilidade Geral de Desmatamento",
      zeroOrNeglegible: "Zero ou Negligível",
      high: "Alto",
      allStatus: "Todos os Status",
      low: "Baixo",
      assessmentIssued: "Avaliação Emitida",
      certificateIssued: "Certificado Emitido",
      assessmentNo: "Número da Avaliação",
      blockchainCertificateDesc: "O Hash de Validação do Certificado Blockchain estará disponível após a Aceitação do Certificado",
      blockchainValidation: "Validação do Certificado Blockchain",
      openBlockchainPage: "Abrir Página Blockchain",
      clickLinkDesc: "Clique no link acima para validar o certificado no blockchain",
      "Zero/Negligible Deforestation Probability": "Probabilidade de Desmatamento Zero/Negligível",
      "Zero Deforestation Probability": "Probabilidade de Desmatamento Zero",
      "Low Deforestation Probability": "Baixa Probabilidade de Desmatamento",
      "High Deforestation Probability": "Alta Probabilidade de Desmatamento",
      "Very Low Deforestation Probability": "Muito Baixa Probabilidade de Desmatamento",
      "Medium Deforestation Probability": "Probabilidade Média de Desmatamento",
      "Very High Deforestation Probability": "Muito Alta Probabilidade de Desmatamento",
      disputeReason: "Motivo da Disputa",
      disputeStatus: "Status da Disputa",
      farmRegId: "ID de Registro da Fazenda",
      productionPlaceId: "ID do Local de Produção",
      disputeId: "ID da Disputa",
      disputeArea: "Tamanho da Área",
      disputeResolution: "Resolução da Disputa",
      selectDefaultMeasurementUnit: "Selecione Unidades de Medida Padrão",
      selectDefaultMeasurementUnitInfo: "Permite a seleção das unidades padrão para medição, incluindo especificar a unidade, definir um limite máximo e marcá-la como a opção padrão.",
      maxLimit: "Limite Máximo",
      maxLimitInfo: "Define o valor máximo permitido ou o limite para um determinado parâmetro.",
      asDefault: "Marcar como Padrão",
      productMass: "Massa do Produto",
      productMassUnitInfo: "Especifica a unidade para medir a massa de um produto.",
      volumeUnitInfo: "Especifica a unidade para medir o volume de um produto.",
      supplierInfo: "Uma entidade que fornece bens ou serviços a outra entidade.",
      operatorInfo: "Refere-se a um indivíduo ou entidade responsável por gerenciar ou operar um sistema ou processo.",
      userTypeInfo: "Classifica indivíduos ou entidades com base em seu papel ou permissões dentro do sistema.",
      unit: "Unidade",
      userType: "Tipo de Usuário",
      eudrPortalApiKeys: "Chaves API do Portal EUDR",
      apiKey: "Chave API",
      apiSecret: "Segredo API",
      headingCreatedSuccessfully: "Criado com sucesso",
      headingOrderSuccessfullyUpdated: "Pedido atualizado com sucesso",
      headingOrderSuccessfullyCreated: "Pedido criado com sucesso",
      questionTypeNotDefined: "Tipo de pergunta não definido",
      assessmentRiskMitigationLvl: "Níveis de Mitigação de Riscos da Avaliação",
      assessmentRiskMitigationLvlInfo: "Classifica a gravidade dos riscos associados ao uso da terra, práticas florestais e expansão agrícola. Esses níveis ajudam a identificar o impacto potencial das atividades em áreas florestais e orientam as ações apropriadas para mitigar as consequências negativas. Classifica os níveis de estratégias de mitigação de riscos, incluindo muito alto, alto, médio, baixo e zero/insignificante.",
      deforestationAssessmentRiskToleranceLevel: "Nível de Tolerância ao Risco de Desmatamento na Avaliação",
      dynamicExpiryTime: "Período de Expiração Dinâmico",
      dynamicExpiryTimeInfo: "Define um período de tempo após o qual certos dados ou configurações expiram automaticamente. Configura as configurações relacionadas aos relatórios de desmatamento, incluindo opções para renovação automática.",
      eudrDeforestationAssessment: "Avaliação de Desmatamento EUDR",
      autoRenewalIf: "Renovação Automática Quando Adicionado ao Relatório de Diligência",
      declarationStatements: "Declarações",
      declarationStatementsInfo: "Declarações feitas pela parte responsável certificando a precisão, integridade e autenticidade das informações contidas no relatório.",
      filterDeclaration: "Filtrar Declarações",
      declarationTitle: "Título da Declaração",
      declarationTitleInfo: "Título ou cabeçalho para uma declaração, fornecendo contexto ou resumindo seu conteúdo.",
      applicableCountry: "Países Aplicáveis",
      applicableCountryInfo: "Lista os países aos quais certas configurações ou regulamentos se aplicam.",
      addMore: "Adicionar Mais",
      autoRenewal: "Renovação Automática",
      createNewAssessment: "Criar Nova Avaliação",
      userDimitraAssessment: "Usar Avaliações Dimitra",
      shipmentList: "Lista de Encomendas",
      generalData: "Dados Gerais",
      check: "Verificar",
      eudrComplianceStatus: "Status de Conformidade com o EUDR",
      very_high: "Muito Alto",
      medium: "Médio",
      very_low: "Muito Baixo",
      zeroOrNegligible: "Zero/Negligível",
      veryHigh: "Muito Alto",
      veryLow: "Muito Baixo",
      tooltip: {
        dimitraFarmId: "Identificador único associado a uma fazenda específica no sistema Dimitra.",
        farmName: "O nome designado da fazenda.",
        farmRegistrationId: "Número de registro da fazenda.",
        farmLocation: "Coordenadas geográficas específicas ou localização da fazenda.",
        dimitraFermerId: "Um identificador distinto vinculado a um agricultor individual dentro do sistema Dimitra.",
        farmerName: "Identificação do indivíduo responsável pela fazenda.",
        farmerRegistrationId: "Número de registro do agricultor.",
        assessmentNo: "Número único atribuído à avaliação."
      },
      Red: "Vermelho",
      Yellow: "Amarelo",
      Transparent: "Transparente",
      zeroOrNeglegibleProbability: "Probabilidade de Desmatamento Zero/Negligível",
      //due diligence
      dueDeligence: "Devida Diligência",
      supplierInformation: "Informação do Fornecedor",
      addNewSupplier: "Adicionar Novo Fornecedor",
      name: "Nome",
      lastName: "Sobrenome",
      email: "Email",
      phoneNumber: "Número de Telefone",
      enterSupplierName: "Digite o Nome do Fornecedor",
      enterSupplierLastName:  "Digite o Sobrenome do Fornecedor",
      enterSupplierFirstName: "Digite o Primeiro Nome do Fornecedor",
      enterOperatorName: "Digite o Nome do Operador",
      enterEmailAddress: "Digite o Endereço de Email",
      enterPhoneNumber: "Digite o Número de Telefone",
      whoWillAddPlace: "Quem irá adicionar os dados do local de produção?",
      companyId: "ID da Empresa",
      activity: "Atividade",
      placeOfActivity: "Local da Atividade",
      countryOfActivity: "País da Atividade",
      operatorPlaceOfActivity: "Local de Atividade do Operador",
      operatorCountryOfActivity: "País de Atividade do Operador",
      countryOfEntry: "País de Entrada",
      productDetail: "Detalhes do Produto",
      subProduct: "Sub-Produto",
      productionDescription: "Descrição da Produção",
      netMass: "Massa Líquida",
      volume: "Volume",
      scietificName: "Nome Científico",
      commonName: "Nome Comum",
      eudrDueDeligenceReports: "Relatórios de Devida Diligência EUDR",
      EUDRAssessmentReport: "Relatório de Avaliação EUDR",
      createNewReport: "Criar Novo Relatório",
      eudrRefNo: "Número de Referência EUDR",
      eudrRefNoInfo: "Funcionalidade para encontrar informações específicas relacionadas à remessa.",
      statusInfo: "O status atual da remessa em relação ao relatório de diligência devida.",
      eudrAndInternalRefNo: "Número de Referência EUDR / Interna",
      exporterAndSupplier: "Exportador e Fornecedor",
      internalRefNo: "Número de Referência Interna",
      supplier: "Fornecedor",
      quantity: "Quantidade",
      product: "Produto",
      noOfFarms: "Nº de Fazendas",
      farmsAndQuantity: "Fazendas e Quantidade",
      country: "País",
      lastUpdated: "Última Atualização",
      dueDeligenceStatus: "Status de Devida Diligência",
      edurDueDeligenceReport: "Relatório de Devida Diligência EUDR",
      reject: "Rejeitar",
      discard: "Descartar",
      saveAndContinueLater: "Salvar e Continuar Depois",
      requestAdditionalInformation: "Solicitar Informação Adicional",
      requestAdditionalInformationShort: "Solicitar mais informações",
      uploadToEudr: "Carregar para o EUDR",
      productionPlaces: "Locais de Produção",
      next: "Próximo",
      dueDeligenceReportCreation: "Criação de Relatório de Devida Diligência",
      producer: "Produtor",
      select: "Selecionar",
      productionPlacesFarmAndFarmId: "Local de produção (Fazenda) e ID da Fazenda",
      producerName: "Nome do Produtor",
      addressOfProduction: "Endereço de Produção",
      type: "Tipo",
      geofence: "Geolocalização",
      areaHa: "Área (ha)",
      editGeofence: "Editar Geolocalização",
      totals: "Totais",
      locationVerification: "Verificação de Localização",
      AnalysisOfDeforestationStatus: "Análise do Status de Desmatamento",
      EUDRDeforestationStatus: "Status de Desmatamento EUDR",
      removeAllLowRiskFarm: "Remover todas as fazendas de baixo risco",
      removeAllHighRiskFarm: "Remover todas as fazendas de alto risco",
      attachRiskMigrationDoc: "Anexar um documento de mitigação de risco para todas as fazendas de alto risco",
      removedFarms: "Fazendas removidas da lista",
      generateCertificate: "Gerar Certificado",
      viewDisputeHistory: "Ver Histórico de Disputas",
      disputeAssessment: "Avaliação de Disputa",
      reportDetails: "Detalhes do Relatório",
      productionPlace: "Local de Produção",
      regionalRiskAssessment: "Avaliação de Risco Regional",
      EUDRDeforestationAssessment: "Avaliação de Desmatamento EUDR",
      EUDRcountry: "O país onde a exploração está localizada, ligado ao produto no relatório de due diligence. Ajuda a garantir a rastreabilidade geográfica, conforme exigido pelos regulamentos EUDR.",
      riskAssessment: "Avaliação de Risco",
      legalInformation: "Informação Legal",
      finalReport: "Relatório Final",
      editGeolocation: "Editar Geolocalização",
      producerCountry: "País do Produtor",
      manuallyAddData: "Adicionar Dados Manualmente",
      drawGeofence: "Desenhar Geolocalização",
      uploadFile: "Enviar Arquivo",
      typeyourlocation: "Digite o nome/endereço do seu local",
      numberOfPoints: "Número de Pontos do Polígono",
      viewGeolocation: "Visualizar Geolocalização",
      geoLocation: "Geolocalização",
      Point: "Ponto",
      Circular: "Circular",
      Polygon: "Polígono",
      selectFileToUploadData: "Selecione um arquivo para enviar dados",
      locationVerificationTab: {
        confirmationTitle: "Confirmação",
        confirmationMessage: "Você está prestes a editar os dados de geolocalização desta fazenda. Observe que quaisquer alterações na geolocalização exigirão a re-verificação de todas as etapas relacionadas, incluindo verificação de localização, análise de desmatamento e avaliação de risco regional (verificações de áreas protegidas e indígenas). Alterações no nome da fazenda ou do agricultor não exigirão re-verificação. Deseja continuar?",
      },
      locationModified: {
        headerTitle: "Localizações Modificadas",
        headerDescription: "Detectamos que as seguintes localizações foram modificadas e precisam ser verificadas novamente.",
      },
      processingDialog: {
        modalHeader: "Analisando o Status do Desmatamento",
        modalDescription_first: "Analisando o Status de Desmatamento EUDR",
        modalDescription_second: "Suas fazendas estão passando por uma Análise Automatizada de Desmatamento. Você será redirecionado para a página de lista de Relatórios de Diligência Devida para visualizar o status.",
      },

    elect_default_measurement_units: "Selecionar Unidades de Medida Padrão",
    radius: "Raio",
    maximum_limit: "Limite Máximo",
    product_mass: "Massa do Produto",
    user_type: "Tipo de Usuário",
    eudr_api_keys: "Chaves de API do Portal EUDR",
    api_key: "Chave da API",
    api_secret: "Segredo da API",
    assessment_risk_mitigation_levels: "Níveis de Mitigação de Riscos da Avaliação",
    dynamic_expiry_time_period: "Período de Expiração Dinâmica",
    eudr_deforestation_assessment: "Avaliação de Desmatamento EUDR",
    auto_renewal: "Renovação Automática",
    auto_renewal_when_added_to_the_due_diligence_report: "Renovação Automática Quando Adicionado ao Relatório de Due Diligence",
    declaration_statements: "Declarações",
    filter_declaration_statements: "Filtrar Declarações",
    showing_all: "Mostrando Todos",
    declaration_title: "Título da Declaração",
    applicable_countries: "Países Aplicáveis",
    enabled: "Ativado",
    disabled: "Desativado",
    add_more: "Adicionar Mais",
    mark_as_default: "Marcar como Padrão",
    
    red: "Vermelho",
    transparent: "Transparente",
    darkRed: "Vermelho Escuro",
    brightRed: "Vermelho Brilhante",
    orange: "Laranja",
    lightBlue: "Azul Claro",
    teal: "Azul-petróleo",

    farmList: {
      title: 'Listagem de fazendas EUDR',
      addFarmGeofenceManually: 'Adicionar geocerca da fazenda manualmente',
      importGeofenceInBulk: 'IMPORTAR GEO-CERCAS EM MASSA',
      searchPlaceHolder: 'Pesquisar por nome do agricultor',
      generateCertificate: 'Gerar Certificado',
      requestAssementReport: 'Solicitar Relatório de Avaliação',
      producer: 'Produtor',
      farmNameAndId: 'Nome e ID da fazenda',
      addressOfProduction: 'Endereço de produção',
      registrationDate: 'Data de registro',
      eudrDeforestationStatus: 'Status de Desmatamento EUDR',
      riskAssessmentStatus: 'Status da Avaliação de Riscos',
      assessmentTitle: 'Título da Avaliação',
      assessmentDescription: 'Descrição da Avaliação',
      submissionDate: 'Data de envio',
      expiryDate: 'Data de expiração',
      assessmentStatus: 'Status da Avaliação',
      downloadAsKmx: 'Baixar como KMX',
      downloadAsKml: 'Baixar como KML',
      downloadAsShp: 'Baixar como SHP',
      downloadAsCsv: 'Baixar como CSV',
      downloadAsExcel: 'Baixar como EXCEL',
      downloadAsPdf: 'Baixar como PDF',
      downloadAsGeoJson: 'Baixar como GeoJSON',
      loadingFarms: 'Carregando fazendas'
    },
    dueDeligenceReport: "Configuração do Relatório de Diligência Pública",
    allowPublicDownload:
      "Permitir download público de cercas de fazendas no formato GeoJson",
    showDeforestationSummary:
      "Mostrar resumo do risco de desmatamento EUDR por categoria",
    actions: "Ação",
    cancel: "Cancelar",
    createShipment: "Criar Envio",
    buyerName: "Nome do comprador",
    operator: "Operador",
    download: "Baixar",
    loading:"Carregando...",

     deforestationAssessmentRiskToleranceLevelInfo:
      "Utilize esta ferramenta para configurar qual % de desmatamento, para cada avaliação, é aceitável dentro do seu processo de Avaliação de Riscos. As fazendas com um risco menor ou igual ao definido serão consideradas aptas para permanecer no DDS, sem a necessidade de realizar a Mitigação de Riscos.",
      tons: "tonnellate",

      failedToDeleteQuestion: "Falha ao excluir a pergunta",
      questionOrderSuccessfullyUpdated: "Ordem das perguntas atualizada com sucesso",
      assessmentUpdatedSuccessfully: "Avaliação atualizada com sucesso",
      pleaseWaitCurrentlyUpdatingChecklist: "Aguarde, atualizando a lista de verificação",
     
      riskMitigation: "Mitigação de Riscos",
      assessmentRiskMitigation: "Mitigação de Riscos da Avaliação",
      riskMitigationHistory: "Histórico de Mitigação de Riscos",
      signParticipationSurvey: "Você poderia assinar digitalmente para confirmar sua participação nesta pesquisa?",
      signedBy: "Assinado digitalmente por:",
      assessmentDetails: "Detalhes da avaliação",
      dontShowWarning: "Não mostre este aviso novamente.",
      dateSubmitted: "Data de envio",
      addAComment: "Adicionar um comentário",
      changeAssignee: "Alterar responsável",
      changeStatus: "Alterar status",
      assignedUser: "Usuário atribuído",
      selectAssignee: "Selecionar responsável",
      reply: "Responder",
      discussion: "Discussão",
      attachment: "Anexo",
      sizeKb: "Tamanho (KB)",
      dateAdded: "Data adicionada",

      loadingProductionPlaces: "Carregando locais de produção",
      shipmentStatus: "Status do Envio",
      viewStops: "Ver Paradas",
      enRoute: "Em Rota",
      delivered: "Entregue",
      failed: "Falhou",
      removeEudrDeforestationStatus: "Remover Status de Desmatamento EUDR",
      riskAssessmentStatusIsRequired: "O status da avaliação de risco é obrigatório",
      requestAdditionalInformationPage: {
        descriptionLabel: "Forneça comentários ou instruções específicas na caixa de texto abaixo. Após o envio, o fornecedor será notificado e terá acesso para editar o relatório de due diligence. Você será notificado quando o fornecedor atualizar o relatório.",
        shareAccessLabel: "O fornecedor atualmente não tem acesso a este relatório. Gostaria de compartilhar o acesso com o fornecedor? Escolha como deseja compartilhar o acesso:",
        shareCompleteReportLabel: "Compartilhar relatório completo",
        shareSpecificStepLabel: "Compartilhar etapa específica"
      },
      issueFound: "Problema encontrado",
      complianceRiskWarningsTT: "As notificações de alerta de risco alertam sobre possíveis problemas de conformidade em cada etapa do processo de due diligence. Essas notificações ajudam a garantir que todos os riscos sejam identificados antes de prosseguir para a próxima etapa. Você pode ativar ou desativar esses alertas a qualquer momento nas Configurações do Relatório ou durante a criação do relatório.",

      eudrVerificationNo:"Número de Verificação",
      eudrVerificationNoTT:"Número de verificação recebido da EUDR",
      statusLegend: "Legenda de Status",
      statusLegendInfo: "A legenda de status fornece uma visão geral rápida do status atual do relatório de diligência devida. É usada para indicar o status atual do relatório e as ações que podem ser tomadas para atualizá-lo.",
      sentToExporter: "Enviado ao Exportador",
      approved: "Aprovado",
      updateRequired: "Atualização Necessária",
      rejected: "Rejeitado",
      noExporterFound: "Nenhum exportador encontrado",
      exporterFoundSuccessfully: "Exportador encontrado com sucesso",
      enterExporterEmail: "Digite o e-mail do exportador",
      shareReport: "Compartilhar Relatório",
      exporterInformation: "Informações do Exportador",
      pleaseEnterExporterEmail: "Por favor, insira o e-mail do exportador",
      
  },

  containerTypes: {
    standardDry: "Contêiner Seco Padrão (20ft, 40ft)",
    highCube: "Contêiner de Cubo Alto",
    openTop: "Contêiner Aberto",
    flatRack: "Contêiner de Estrado Plano",
    refrigerated: "Contêiner Refrigerado (Reefer)",
    tank: "Contêiner de Tanque",
    ventilated: "Contêiner Ventilado",
    insulated: "Contêiner Isolado",
    platform: "Contêiner de Plataforma",
    halfHeight: "Contêiner de Meia Altura",
    bulk: "Contêiner a Granel"
  },

  dueDiligence: {
    comments: "Comentários",
    commentsRegardingStatement: "comentários sobre a declaração",
    countryOfProduction: "País de Produção",
    countryOfProductionTT: "País de Produção",
    containerId:"d do contêiner",
    createWithoutRiskAssessment: {
      title: "Criar DDS sem Avaliação de Risco",
      message: "Você deseja criar um DDS sem adicionar a Avaliação de Risco? Se sim, as regras de verificação de reclamações pularão esta etapa.",
      confirmBtnText: "Sim",
      cancelBtnText: "Não"
    },
    noAssessmentWarning: "O relatório DDS está faltando avaliações de risco.",
    disputeReason: "Por favor, escolha um motivo de disputa.",
    agricultureAgreement: "Por favor, aceite o termo antes de prosseguir.",
    attachDisputeFile: "Por favor, anexe um arquivo antes de abrir uma disputa.",

    // Activity Log translations
    activityLog: "Registro de atividades",
    activityLogTT: "Registro das ações realizadas neste relatório.",
    user: "Usuário",
    userRole: "Função do usuário",
    ipAddress: "Endereço IP",
    segment: "Segmento",
    activityDescription: "Descrição da atividade",
    listOfFarmsInfo:"Uma exibição abrangente das fazendas, incluindo informações como local de produção, nome do produtor, país de operação, área de terra em hectares, tipo de atividades agrícolas, avaliações relacionadas ao desmatamento e avaliações de riscos potenciais associados às operações agrícolas.",
    producerTT: "Seleção de produtores ou fabricantes envolvidos na cadeia de suprimentos.",
    supplierInformationTT: "Detalhes sobre a entidade que fornece bens ou serviços.",
    operatorTooltip: "Selecione o operador da lista pré-registrada no sistema",
    supplierTooltip: "Selecione o fornecedor da lista pré-registrada no sistema.",
    requiredAssessmentTooltip: "Escolha as informações de avaliação necessárias.",
    internalRefNoTooltip: "Um identificador único atribuído dentro de uma organização ou sistema para referenciar dados, transações ou registros específicos para fins de rastreamento e gestão internos.",
    eudrRefNoTooltip: "Refere-se a um identificador único associado ao Regulamento Europeu de Desmatamento (EUDR), geralmente utilizado para rastrear e fazer referência a informações relacionadas ao cumprimento das regulamentações de desmatamento.",
    companyIdTooltip: "Um identificador distinto atribuído a uma empresa ou organização para fins de identificação e rastreamento, geralmente usado em sistemas, bancos de dados ou quadros regulatórios.",
    placeOfActivityTooltip: "Especifique o país do operador onde as atividades são realizadas e o país onde o produto entrará no mercado da UE. Esses detalhes são essenciais para o cumprimento preciso dos requisitos do EUDR.",
    productDetailToolTip: "Fornece informações detalhadas sobre o produto, incluindo seu nome, massa líquida, volume, nome científico e nome comum.",
    productToolTip: "Nome do produto. Refere-se a um item ou mercadoria tangível produzida, fabricada ou comercializada por uma empresa.",
    productDescToolTip: "Fornece uma explicação ou resumo textual das características, funções ou atributos de um produto, com o objetivo de informar os usuários ou clientes sobre sua natureza ou funcionalidade.",
    subProductToolTip: "Nome do Subproduto. Denota uma categoria ou subconjunto específico de uma categoria de produto maior, geralmente usado para classificação ou diferenciação adicional dentro de uma hierarquia de produtos.",
    netMassTooltTip: "Indica o peso de um produto ou item, geralmente excluindo o peso da embalagem ou outros materiais.",
    volumeToolTip: "Refere-se à quantidade de espaço ocupada por um produto ou substância, geralmente medido em unidades cúbicas, como metros cúbicos ou pés cúbicos, utilizado para quantificar a capacidade ou quantidade no espaço tridimensional.",
    scientificNameToolTip: "Nome taxonômico de um organismo que consiste no gênero e na espécie, por exemplo, Coffea Arabica, Theobroma cacao L.",
    commonNameToolTip: "Um nome baseado na linguagem cotidiana, por exemplo, Cacau, Café.",
    manualProductionPlaceTooltip: "Processo de entrada manual de locais de fabricação no sistema.",
    producerNameTT: "O nome de um indivíduo/empresa/organização que cria e fornece bens ou serviços.",
    producerCountryTT: "A nação de origem de onde vem o produtor.",

    productionPlaceUsingLots:'Selecionar Locais de Produção utilizando Lotes',
    dueDiligence: "Diligência Devida EUDR",
    assementBuilder: "Construtor de Avaliações",
    assessment: "Avaliação",
    assessmentsList: "Lista de Avaliações",
    createAssessment: "Criar Avaliação",
    assessmentName: "Nome da Avaliação",
    assessmentNameInfo: "Funcionalidade para encontrar avaliações ou informações específicas.",
    searchAssessment: "Pesquisar Avaliação",
    selectProcess: "Selecionar Processo de Avaliação",
    assessSettings: "Configurações de Avaliação",
    assessmentTitle: "Título da Avaliação",
    assessmentTitleInfo: "Nome que identifica uma avaliação.",
    assessDescription: "Descrição da Avaliação",
    assessDescriptionInfo: "Breve explicação do propósito ou conteúdo da avaliação.",
    describeAsessment: "Descreva a Avaliação",
    selectCountry: "Selecione o País",
    expiryTime: "Tempo de Validade",
    expiryTimeInfo: "Duração até que a avaliação expire ou se torne inválida.",
    noQuestionEachStep: "Número de Perguntas",
    byHeadings: "Por Títulos",
    assessmentStatus: "Status da Avaliação",
    multiStepAssess: "Avaliação em Múltiplas Etapas",
    allowAssessment: "Permitir que a avaliação seja respondida mais de uma vez",
    onlyIfExpired: "Somente se Expirado",
    atAnyTime: "A Qualquer Momento",
    editAssessmentDetails: "Editar Pergunta da Avaliação",
    assessmentDetail: "Detalhes da Avaliação",
    addQuestion: "Adicionar Pergunta da Avaliação",
    attachFiles: "Anexar Arquivos",
    digitalSignature: "Assinatura Digital",
    showChecklist: "Mostrar Checklist",
    hideChecklist: "Ocultar Checklist",
    fileType: "Tipo de Arquivo",
    allowMultipleFile: "Permitir Múltiplos Anexos",
    allowComment: "Permitir Comentários",
    uploadSignatureFile: "Enviar Arquivo de Assinatura",
    drawSignature: "Desenhar Assinatura",
    addSubHeading: "Adicionar Subtítulo",
    heading: "Título",
    headingInfo: "Título sob o qual a pergunta da avaliação será categorizada. Um menu suspenso para selecionar o título.",
    subHeading: "Subtítulo",

    dueDiligenceReports: "Relatório de Devida Diligência",
    manageFarms: "Gerenciar Fazendas",
    disputeResolution: "Resolução de Disputas",
    suppliers: "Fornecedores",
    shipments: "Envios",
    dueDiligenceGuide: "Guia de Diligência Devida",

    selectRequiredAssessment: "Selecione Avaliações Requeridas",
    filterAssessments: "Filtrar Avaliações",
    dueDiligenceReportCreation: "Criação de Relatório de Diligência Devida",

    dueDiligenceNew: "Diligência Devida",
    createNewReport: "Criar Novo Relatório",
    operator: "Operador",
    supplier: "Fornecedor",
    addMoreAssessments: "Adicionar Mais Avaliações",
    internalReferenceNumber: "Número de Referência Interna",
    referenceNumber: "Número de Referência",
    domestic: "Doméstico",
    import: "Importação",
    export: "Exportação",
    selectProduct: "Selecionar Produto",
    selectSubProduct: "Selecionar Subproduto",
    addnewSupplier: "Adicionar Novo Fornecedor",
    farmDeforestationReport: "Relatório de Desmatamento da Fazenda",

    addProductionPlaceData: "Adicionar Dados do Local de Produção",
    addProductionPlaceDataTooltip: "Escolha como deseja adicionar os dados",
    addProductionPlaceDataDesc:
      "Crie seus relatórios integrando dados de produção de várias fontes. Selecione uma ou várias fontes para compilar uma lista abrangente de locais de produção para seus relatórios.",
    dimitraApps: "Aplicativos Dimitra",
    addNew: "Adicionar Novo",
    existingData: "Dados Existentes",
    manualDataEntry: "Entrada de Dados Manual",
    importFile: "Importar Arquivo",
    connectedCoffee: "Café Conectado",
    connectedCacao: "Cacau Conectado",
    connectedFarmer: "Agricultor Conectado",
    manaulProductionPlace: "Entrada Manual de Dados de Locais de Produção",
        farmerRegistrationId: "ID de Registro do Agricultor",
farmRegistrationId:  "ID de Registro da Fazenda",
    manaulProductionPlaceTooltip: "Processo de entrada manual de locais de fabricação no sistema.",
    addProductionPlace: "Adicionar Local de Produção",
    producerName: "Nome do Produtor",
    producerCountry: "País do Produtor",
    totalArea: "Área Total",
    number: "Número",
    productionPlaceDesc: "Descrição do Local de Produção",
    area: "Área (ha)",
    type: "Tipo",
    actions: "Ações",
    selectType: "Selecionar Tipo",
    importProductionPlace: "Importar Local de Produção",
    downloadXLSFormat: "Baixar Formato XLS",
    downloadGeoJsonFormat: "Baixar Formato GeoJSON",
    downloadXMLFormat: "Baixar Formato XML",
    downloadFileFormatTemplates: "Baixar Modelos de Formato de Arquivo",
    importantNote: "Nota Importante",
    pleaseProvideFollowing:
      "Por favor, forneça o seguinte formato (GeoJSON e XML)",
    existingProductionPlaces: "Locais de Produção Existentes",
    productionPlaceAndFarmID: "Local de Produção e ID da Fazenda",
    selectFileToUploadData: "Selecionar arquivo para enviar os dados",
    filterByDate: "Filtrar por data",
    dateOfRegister: "Data de Registro",
    dateOfLastReport: "Data do Último Relatório",
    clearAll: "Limpar Tudo",
    addLocation: "Adicionar Local",

    pleaseCompleteBeforeProceedingToNext:
      "Por favor, complete a seção de detalhes do relatório antes de prosseguir para a próxima etapa.",
    progressSavedSuccessMsg: "Progresso salvo com sucesso!",
    failedSavedProgress:
      "Falha ao salvar o progresso. Por favor, tente novamente.",
    failedToCreateReportDetails:
      "Falha ao criar ReportDetails. Por favor, tente novamente.",
    unExpectedErrorMsg:
      "Ocorreu um erro inesperado. Por favor, tente novamente.",
    selectAssessment: "Selecionar Avaliação",
    confirmationPopup: "Popup de Confirmação",
    confirmationPopupMsg:
      "Tem certeza de que deseja descartar este relatório? Confirmar esta ação resultará na exclusão permanente.",
    warningPopup: "Popup de Aviso",
    warningPopupMsg:
      "Tem certeza de que deseja rejeitar este relatório? Nota: Os dados deste relatório serão salvos após a rejeição caso você queira revisá-los posteriormente.",
    automatedDeforestationProgressText:
      "Verificação automatizada de desmatamento dos dados de geocerca e identificação de casos críticos",
    someRiskWereIdentifiedText:
      "Alguns riscos foram identificados na fazenda a seguir, você deve revisar a fazenda com os riscos identificados e mitigá-los antes de passar para a próxima etapa.",
    riskAssessmentAndMitigation: "Avaliação e Mitigação de Riscos",
    riskAssessmentStatus: "Status da Avaliação de Riscos",
    riskAssessment: "Avaliação de Riscos",
    uploadRiskAssessment: "Fazer Upload da Avaliação de Riscos",
    uploadRiskAssessmentTT: "Ação para fazer upload de um documento de avaliação de riscos.",
    manualFillOutAssessment: "Preencher avaliação manualmente",
    manualFillOutAssessmentTT: "Ação para preencher um formulário de avaliação manualmente.",
    criteria : "Critérios (b, f e g)",
    downloadAssessmentForm: "Baixar Formulário de Avaliação",
    addSignature: "Adicionar Assinatura",
    uploadImage: "Carregar Imagem",
    createNewDueDiligenceProgress: "Criar Novo Processo de Devida Diligência",
    usageLimits: "Limites de Uso",
    totalReports: "Total de Relatórios",
    eudrDeforestationAssessments: "Avaliações de Desmatamento EUDR",
    totalAssessments: "Total de Avaliações",
    listOfFarms: "Lista de Fazendas",
    perMonth: "Por Mês",
    share: "Compartilhar",
    viewReport: "Ver Relatório",
    viewReportSummary: "Ver resumo do relatório",
    copy: "Copiar",
    copyAndCreateNew: "Copiar e Criar Novo",
    listOfSupplier: "Lista de Fornecedores",
    addNewSupplier: "Adicionar novos fornecedores",
    editSupplier: "Editar Fornecedor",
    supplierName: "Nome do Fornecedor",
    listOfOperators: "Lista de Operadores",
    addNewOperator: "Adicionar novos operadores",
    operatorName: "Nome do Operador",
    operators: "Operadores",
    editOperator: "Editar Operador",
    eoriNumber: "Número EORI",
    isoCode: "Código ISO",
    enterEmailAddress: "Digite o endereço de e-mail",
    enterFirstName: "Digite o primeiro nome",
    enterLastName: "Digite o sobrenome",
    enterEORINumber: "Digite o número EORI",
    viewAssessment: "Ver Avaliação",
    myFarms: "Minhas Fazendas",
    listOfProducers: "Lista de Produtores",
    producers: "Produtores",
    addNewProducer: "Adicionar Novo Produtor",
    lastAssessment: "Última Avaliação",
    noOfFarms: "N.º de Fazendas",
    shipmentID: "ID de Envio",
    noOfReports: "N.º de Relatórios",
    operatorSelect:
      "Operador: Escolha esta opção se você, como operador, será responsável por adicionar dados do local de produção. Você terá a opção de fornecer uma lista de produtores, suas fazendas e as geolocalizações dentro do aplicativo.",
    supplierSelect:
      "Fornecedor: Escolha esta opção se o fornecedor for responsável por adicionar dados do local de produção. Eles terão acesso para fornecer a lista de produtores, suas fazendas e as geolocalizações diretamente no aplicativo.",
    selectWhoWillAddPlaceData:
      "Selecione quem adicionará os dados do local de produção",
    selectUsers: "Selecionar Usuários",
    country: "País",
    mutiStepHeadingLable: "Crie um novo passo para cada subtítulo",
    logistics: "Logística",
    editSubHeading: "Editar Subtítulo",
    headingTitle: "Título do Cabeçalho",
    partOfOrigin: "Parte de Origem",
    destination: "Parte do Destino",
    addStop: "Adicionar uma parada",
    stop: "parada",
    enterStop: "Insira a parada",
    shipmentList: "Lista de Remessas",
    createShipment: "Criar nova remessa",
    disputeAssessment: "Avaliação de Disputa",
    multiStepQuestion1:"Crie um novo passo depois de",
    questions: "Questões",
    questionsInfo: "Quantidade de perguntas em cada etapa de uma avaliação de múltiplas etapas.",
    confirmation: "Confirmação",
    saveAndConfirmationMessage:"Tem certeza de que deseja salvar as alterações?",
    supplierNotRegisterContent:"O fornecedor não está registrado. Deseja enviar uma notificação para o fornecedor para se juntar ao aplicativo via e-mail?",
    downloadAsPDF: "Baixar como PDF",
    downloadAsJSON: "Baixar como JSON",
    downloadOptions: "Opções de Download",
    supplierTT: "Seleção de fornecedores ou fabricantes envolvidos na cadeia de suprimentos.",
    pleaseSelectAtLeastOneItem: "Por favor, selecione pelo menos um item.",

    pleaseSelectAtLeastOneSource: "Por favor, selecione pelo menos uma fonte.",
    invalidFileFormatPleaseUploadValidFile: "Formato de arquivo inválido. Por favor, carregue um arquivo .xml, .kml ou .geojson.",
    pleaseUploadAValidFile: "Por favor, carregue um arquivo válido.",
    fileUploadedDuccessfully: "Arquivo carregado com sucesso!",
    anErrorOccured: "Ocorreu um erro.",
    successfullyUpdatedDefaultFarmArea: "Área agrícola padrão atualizada com sucesso.",
    pleaseAddProductionPlacesData: "Por favor, adicione os dados dos locais de produção.",
    failedToFetchSettings: "Não foi possível obter as configurações. Por favor, verifique suas configurações ou entre em contato com o suporte se o problema persistir.",
    updatedDueDiligenceReport: "Relatório de diligência atualizado.",
    updatedDueDiligenceStatus: "O status da Diligência Devida foi atualizado com sucesso.",
    failedToWriteDeforestationDataToBlockchain: "Falha ao gravar os dados de desmatamento no blockchain, tente novamente.",
    countryIsRequired: "País é obrigatório",
    dueDiligenceReportsInfo: "Documentação detalhada que resume as descobertas e resultados do processo de diligência devida. Esses relatórios fornecem informações sobre a avaliação realizada, incluindo quaisquer riscos identificados, status de conformidade e recomendações para mitigação ou melhoria.",
    listOfFarmsTT: "Uma exibição abrangente de fazendas, incluindo informações como a localização de produção, nome do produtor, país de operação, área de terra em hectares, tipo de atividades agrícolas, avaliações relacionadas ao desmatamento e avaliações de riscos potenciais associados às operações da fazenda.",
    loadingPleaseWait: "Carregando... Por favor, aguarde" ,
    existingProductionPlacesTT: "Exibe uma lista de locais de produção existentes, juntamente com detalhes como o nome do produtor, país, área, tipo e status da avaliação.",
    analyzingDesc: "Suas fazendas estão passando por uma Análise Automatizada de Desmatamento. Você será redirecionado para a página da lista de Relatórios de Due Diligence para ver o status.",
    successfullyGeneratedEUDRDeforestationStatus: "O status de desmatamento do EUDR foi gerado com sucesso.",
    riskAssessmentAndMitigationTT: "Identificar riscos potenciais e implementar estratégias para minimizar seu impacto ou a probabilidade de ocorrência. Inclui avaliar perigos, analisar suas possíveis consequências e desenvolver planos para abordá-los ou mitigá-los de forma eficaz.", 
    eudrRefNoTT: "Um identificador único atribuído a cada relatório de due diligence, facilitando o rastreamento e a verificação de conformidade dentro do quadro do Regulamento de Desmatamento da União Europeia (EUDR)." ,
    
    operatorData: "Dados do Operador",
    operatorDataTT: "Informações sobre o operador.",
    supplierData: "Dados do Fornecedor",
    supplierDataTT: "Informações sobre o fornecedor.",
    reportSummary: "Resumo do Risco",
    reportSummaryTT: "Breve visão geral do relatório.",
    totalNoOfGeofencePolygon: "Número Total de Polígonos de Geocerca",
    totalNoOfGeofencePolygonTT: "Contagem total de polígonos de geocerca.",
    totalNoOfGeofencePoint: "Número Total de Pontos de Geocerca",
    totalNoOfGeofencePointTT: "Contagem total de pontos de geocerca.",
    totalNoOfFarms: "Número Total de Fazendas",
    totalNoOfFarmsTT: "Contagem total de fazendas.",
    totalAreaFinalReport: "Área Total (ha)",
    totalNoOfDeforestation: "Número Total de Desmatamentos",
    totalNoOfDeforestationTT: "Contagem total de avaliações de desmatamento.",
    totalNoOfHighDeforestation: "Número Total de Desmatamento Alto",
    totalNoOfHighDeforestationTT: "Contagem total de fazendas com desmatamento alto.",
    totalNoOfRiskAssessments: "Número Total de Avaliações de Risco",
    totalNoOfRiskAssessmentsTT: "Contagem total de avaliações de risco.",
    productDetail: "Detalhes do Produto",
    productDetailTT: "Informações sobre o produto.",
    product: "Produto",
    productTT: "Nome do produto. Refere-se a um item tangível ou mercadoria produzida, fabricada ou comercializada por uma empresa ou organização, frequentemente categorizada com base no tipo, características ou finalidade.",
    productDescription: "Descrição do Produto",
    productDescriptionTT: "Fornece uma explicação textual ou resumo das características, funções ou atributos de um produto, visando informar os usuários ou clientes sobre sua natureza ou funcionalidade.",
    netMass: "Massa Líquida",
    netMassTT: "Indica o peso de um produto ou item, normalmente excluindo o peso da embalagem ou outros materiais associados, geralmente expresso em unidades de massa como quilogramas ou libras.",
    volume: "Volume",
    volumeTT: "Refere-se à quantidade de espaço ocupada por um produto ou substância, geralmente medido em unidades cúbicas como metros cúbicos ou pés cúbicos, usado para quantificar a capacidade ou quantidade em um espaço tridimensional.",
    scientificName: "Nome Científico",
    scientificNameTT: "Nome taxonômico de um organismo que consiste no gênero e na espécie, por exemplo, Coffea Arabica, Theobroma cacao L.",
    commonName: "Nome Comum",
    commonNameTT: "Nome baseado na linguagem comum da vida cotidiana, por exemplo, Cacau, Café.",

    successfullyUploadedToTheBlockchain: "Sucesso! O Relatório de Diligência Devida da EUDR foi carregado com sucesso na Blockchain.",
    complianceRiskWarning: "Aviso de Risco de Conformidade",
    issueIdentifiedOnFarms: "Foram identificados problemas em algumas fazendas que precisam de atenção antes de prosseguir para o próximo passo. Você pode optar por resolver esses problemas agora ou continuar para o próximo passo e resolvê-los mais tarde.",
    blockchainDescs: [
      'Carregando relatório para a blockchain, por favor, aguarde...', 
      'Seu relatório de Devida Diligência está sendo carregado para a blockchain. Você será redirecionado para a lista de Relatórios de Devida Diligência para visualizar o status.'
    ],
    reportDownloadedSuccessfully: "Relatório baixado com sucesso!",
    operatorDecleration: "Declaração do Operador",
    supplierDecleration: "Declaração do Fornecedor",
    internalReferenceNumberTT:
     "Um número de referência interno é um identificador exclusivo atribuído a um relatório de diligência devida dentro do sistema.",
    fRinternalReferenceNumberTT: "Um número de referência interno é um identificador exclusivo atribuído a um relatório de diligência devida dentro do sistema.",
    deleteProductionPlaceData: "Excluir Dados do Local de Produção",
    areYouSureYouWantToContinueThisAction: "Tem certeza de que deseja continuar com esta ação?",
    noAssessment:"Sem avaliação",
    dueDiligenceReportStatus: "Status do Relatório de Due Diligence",
    declarationStatement: "Declaração do Operador",
    undoDelete: "Desfazer Exclusão",
    analyzingDeforestation: "Analisando o Desmatamento",
    processingFarm: "Processando Fazenda",

    uploadingToBlockchain: "Carregando relatório para a blockchain, por favor, aguarde...",
    beingUploadToBlockChain: "Seu relatório de Devida Diligência está sendo carregado na blockchain. Você será redirecionado para a página da lista de Relatórios de Devida Diligência para visualizar o status.",
    uploading: "Carregando",
    attachFile: "Anexar Arquivo",
    close: "Fechar",
    status: "Status",
    lotID: "ID do Lote",
    noOfFarm: "Nº de Fazendas",
    processingDate: "Data de Processamento",
    origin: "Origem",
    selectUsingLots: "Selecionar Locais de Produção Usando Lotes",
    productionPlaceUsingFarms: "Selecionar Locais de Produção Usando Fazendas",
    onlyShowFarmsWithIssues: "Mostrar apenas fazendas com problemas",
    searchFarmName: "Buscar pelo Nome da Fazenda",
    pleaseSelectFarmType: "Por favor selecione o tipo de Fazenda",
    deforestationReports: "Relatório(s) de Desmatamento",
    stateStatement: "Região do país onde a fazenda está localizada.",
    countryState: "País onde a fazenda está localizada.",
    cityStatement: "Cidade onde a fazenda está localizada.",
    farmAddress: "Endereço da Localização da Fazenda",
    farmNumber: "Número da Fazenda",
    primaryLocation: "Localização Primária",
    addNewLocation: "Adicionar Nova Localização",
    totalFarmSize: "Tamanho Total da Fazenda",
    addNewZone: "Adicionar Nova Zona",
    locationZone: "Zona de Localização",
    noZoneMessage: "Nenhuma zona foi registrada ainda.",
    noZoneRequest: "Por favor, clique em Adicionar Nova Zona para criar uma zona para esta fazenda.",
    farmOwnershipType: "Tipo de Propriedade do Agricultor",
    farmGoals: "Objetivos da Fazenda",
    farmCertifications: "Certificações da Fazenda",
    enterHere: "Insira aqui",
    farmerName: "Nome do Agricultor",
    personal: "Pessoal",
    community: "Comunidade",
    farmType: "Tipo de Fazenda",
    "organic": "Orgânico",
    "conventional": "Convencional",
    viewLocation: "Ver Geolocalização",
    netMassKG: "Massa Líquida (kg)",
    volumeM3: "Volume (m³)",
    volumeM: "Volume",
    areaInHA: "Área (ha)",
    eudrUploadedToBlockChain: "Sucesso! O Relatório de Devida Diligência EUDR foi carregado com sucesso na Blockchain.",
    viewDeforestationAssessment: "Ver Avaliação de Desmatamento",
    viewDeforestationCertificate: "Ver Certificado de Desmatamento",
    selectCountries: "Selecionar Países",
    writingToBlockchain: "Escrevendo na Blockchain",
   
    cattle: "Gado",
    "coffee": "Café",
    cocoa: "Cacau",
    "wood": "Madeira",
    "soya": "Soja",
    "rubber": "Borracha",
    "oilPlam": "Palma de óleo",

    subProduct1: "0102 21 , 0102 29 Gado vivo",
    subProduct2: "0201 Carne de gado, fresca ou refrigerada",
    subProduct3: "0202 Carne de gado, congelada",
    subProduct4: "0206 10 Miudezas comestíveis de bovinos, frescas ou refrigeradas",
    subProduct5: "0206 22 Fígados bovinos comestíveis, congelados",
    subProduct6: "0206 29 Miudezas comestíveis de bovinos (excluindo línguas e fígados), congeladas",
    subProduct7: "1602 50 Outras preparações e conservas de carne, miudezas, sangue, de bovinos",
    subProduct8: "4101 Couros e peles em bruto, de bovinos (frescos, ou salgados, secos, tratados pela cal, picles ou conservados de outro modo, mas não curtidos, nem apergaminhados nem preparados de outro modo), mesmo depilados ou divididos",
    subProduct9: "4104 Couros e peles curtidos ou em crosta, de bovinos, depilados, mesmo divididos, mas não preparados de outro modo",
    subProduct10: "4107 Couros de bovinos preparados posteriormente após curtimenta ou após secagem, incluindo couros e peles apergaminhados, depilados, mesmo divididos, excepto os couros da posição 4114",
    subProduct11: "1801 Grãos de cacau inteiros ou partidos, crus ou torrados",
    subProduct12: "1802 Cascas, cascas, películas e outros desperdícios de cacau",
    subProduct13: "1803 Pasta de cacau, mesmo desengordurada",
    subProduct14: "1804 Manteiga de cacau, gordura e óleo",
    subProduct15: "1805 Cacau em pó, sem adição de açúcar ou de outros edulcorantes",
    subProduct16: "1806 Chocolate e outras preparações alimentícias que contenham cacau",
    subProduct17: "0901 Café, mesmo torrado ou descafeinado; cascas e cascas de café; substitutos do café contendo café em qualquer proporção",
    subProduct18: "1207 10 Nozes e caroços de palma",
    subProduct19: "1511 Óleo de palma e respectivas frações, mesmo refinados, mas não quimicamente modificados",
    subProduct20: "1513 21 Óleos brutos de palmiste e de babaçu e respectivas frações, mesmo refinados, mas não quimicamente modificados",
    subProduct21: "1513 29 Óleos de palmiste e de babaçu e respetivas frações, mesmo refinados, mas não quimicamente modificados (exceto petróleo bruto)",
    subProduct22: "2306 60 Tortas e outros resíduos sólidos de amêndoas ou de amêndoas de palma, mesmo triturados ou em pellets, resultantes da extração de gorduras ou óleos de amêndoas ou amêndoas de palma",
    subProduct23: "2905 45 Glicerol, com pureza igual ou superior a 95 % (calculada em relação ao peso do produto seco)",
    subProduct24: "2915 70 Ácido palmítico, ácido esteárico, seus sais e ésteres",
    subProduct25: "2915 90 Ácidos monocarboxílicos acíclicos saturados, seus anidridos, halogenetos, peróxidos e perácidos; seus derivados halogenados, sulfonados, nitrados ou nitrosados ​​(excluindo ácido fórmico, ácido acético, ácidos mono, di ou tricloroacéticos, ácido propiónico, ácidos butanóicos, ácidos pentanóicos, ácido palmítico, ácido esteárico, seus sais e ésteres, e anidrido acético)",
    subProduct26: "3823 11 Ácido esteárico industrial",
    subProduct27: "3823 12 Ácido oleico industrial",
    subProduct28: "3823 19 Ácidos gordos monocarboxílicos industriais; óleos ácidos provenientes de refinação (excluindo ácido esteárico, ácido oleico e ácidos gordos de tall oil)",
    subProduct29: "3823 70 Álcoois graxos industriais",
    subProduct30: "4001 Borracha natural, balata, guta-percha, guaiule, chicle e gomas naturais semelhantes, em formas primárias ou em chapas, folhas ou tiras",
    subProduct31: "4005 Borracha composta, não vulcanizada, em formas primárias ou em chapas, folhas ou tiras",
    subProduct32: "4006 Borracha não vulcanizada sob outras formas (por exemplo, varetas, tubos e perfis) e artigos (por exemplo, discos e anéis)",
    subProduct33: "4007 Fio e cordão de borracha vulcanizada",
    subProduct34: "4008 Placas, folhas, tiras, varetas e perfis, de borracha vulcanizada não endurecida",
    subProduct35: "4010 Correias transportadoras ou de transmissão, de borracha vulcanizada",
    subProduct36: "4011 Pneus novos, de borracha",
    subProduct37: "4012 Pneus recauchutados ou usados, de borracha; pneus maciços ou almofadados, bandas de rodagem e abas de pneus, de borracha",
    subProduct38: "4013 Câmaras de ar, de borracha",
    subProduct39: "4015 Vestuário e seus acessórios (incluindo luvas, mitenes e mitenes), para todos os usos, de borracha vulcanizada, exceto borracha endurecida",
    subProduct40: "4016 Outras obras de borracha vulcanizada, exceto borracha endurecida, não especificadas em outras posições do Capítulo 40",
    subProduct41: "4017 Borracha dura (por exemplo, ebonite) sob todas as formas, incluindo desperdícios e sucata; artigos de borracha dura",
    subProduct42: "1201 Soja, mesmo triturada",
    subProduct43: "1208 10 Farinha e sêmola de soja",
    subProduct44: "1507 Óleo de soja e respetivas frações, mesmo refinados, mas não quimicamente modificados",
    subProduct45: "2304 Tortas e outros resíduos sólidos, mesmo triturados ou em pellets, da extração do óleo de soja",
    subProduct46: "4401 Lenha para lenha, em troncos, em tarugos, em gravetos, em feixes ou em formas semelhantes; madeira em lascas ou partículas; serragem e desperdícios e resíduos de madeira, mesmo aglomerados em toras, briquetes, pellets ou formas semelhantes",
    subProduct47: "4402 Carvão vegetal (incluído o carvão de cascas e de frutos secos), mesmo aglomerado",
    subProduct48: "4403 Madeira em bruto, mesmo descascada ou de alburno, ou desbastada",
    subProduct49: "4404 Madeira de Aro; postes divididos; estacas, estacas e estacas de madeira, pontiagudas, mas não serradas longitudinalmente; varas de madeira, desbastadas, mas não torneadas, dobradas ou trabalhadas de outro modo, próprias para a fabricação de bengalas, guarda-chuvas, cabos de ferramentas e semelhantes; madeira lascada e similares",
    subProduct50: "4405 Lã de madeira; farinha de madeira",
    subProduct51: "4406 Travessas para caminhos de ferro ou elétricos, de madeira",
    subProduct52: "4407 Madeira serrada ou fendida longitudinalmente, cortada longitudinalmente ou desenrolada, mesmo aplainada, lixada ou unida pelas extremidades, de espessura superior a 6 mm",
    subProduct53: "4408 Folhas para folheados (incluídas as obtidas por corte de madeira estratificada), para contraplacados ou para outras madeiras estratificadas semelhantes e outras madeiras, serradas longitudinalmente, cortadas ou desenroladas, mesmo aplainadas, lixadas, unidas ou unidas pelas extremidades, de espessura não superior a 6 mm",
    subProduct54: "4409 Madeira (incluindo as tiras e frisos para soalhos de parquet, não montada) moldada continuamente (com linguetas, ranhuras, reentrâncias, chanfradas, com juntas em V, com contas, moldadas, arredondadas ou semelhantes) ao longo de qualquer das suas arestas, extremidades ou faces, mesmo não aplainado, lixado ou unido nas extremidades",
    subProduct55: "4410 Painéis de partículas, painéis de partículas orientadas (OSB) e painéis semelhantes (por exemplo, waferboard), de madeira ou de outras matérias lenhosas, mesmo aglomerados com resinas ou outros aglutinantes orgânicos",
    subProduct56: "4411 Painéis de fibras de madeira ou de outras matérias lenhosas, mesmo ligados com resinas ou outras substâncias orgânicas",
    subProduct57: "4412 Contraplacado, painéis folheados e madeiras estratificadas semelhantes",
    subProduct58: "4413 Madeira densificada, em blocos, placas, tiras ou perfis",
    subProduct59: "4414 Molduras de madeira para pinturas, fotografias, espelhos ou objetos semelhantes",
    subProduct60: "4415 Caixotes, caixas, engradados, barricas e embalagens semelhantes, de madeira; carretéis para cabos em madeira; paletes simples, paletes-caixas e outros estrados para carga, de madeira;",
    subProduct61: "taipais de paletes de madeira (não incluindo material de embalagem utilizado exclusivamente como material de embalagem para apoiar, proteger ou transportar outro produto colocado no mercado)",
    subProduct62: "4416 Barris, barricas, cubas, selhas e outras obras de tanoeiro e suas partes, de madeira, incluídas as aduelas",
    subProduct63: "4417 Ferramentas, corpos de ferramentas, cabos de ferramentas, corpos e cabos de vassouras ou escovas, em madeira; formas para botas ou sapatos e árvores, de madeira",
    subProduct64: "4418 Marcenaria e carpintaria de madeira para construção, incluindo painéis celulares de madeira, painéis montados para pisos, telhas e telhas",
    subProduct65: "4419 Utensílios de mesa e de cozinha, de madeira",
    subProduct66: "4420 Madeira marchetada e madeira incrustada; caixões e estojos para joalharia ou ourivesaria e artefactos semelhantes, de madeira; estatuetas e outros objetos de ornamentação, em madeira; artigos de mobiliário de madeira que não se incluam no Capítulo 94",
    subProduct67: "4421 Outras obras de madeira",
    subProduct68: "Pasta e papel dos capítulos 47 e 48 da Nomenclatura Combinada, com exceção dos produtos à base de bambu e dos produtos valorizados (desperdícios e aparas)",
    subProduct69: "49 Livros, jornais, gravuras e outros produtos da indústria gráfica, impressos, manuscritos, textos datilografados e plantas, de papel",
    subProduct70: "9401 Assentos (exceto os da posição 9402), mesmo transformáveis ​​em camas, e suas partes, de madeira",
    subProduct71: "9403 30 , 9403 40 , 9403 50 , 9403 60 e 9403 91 Móveis de madeira e suas partes",
    subProduct72: "9406 10 Construções pré-fabricadas de madeira",


    selectStatus: "Selecionar Status",
    compilanceRiskWarning: "Aviso de Risco de Conformidade",

       
    selectProductionPlacesUsingLots: "Selecione os locais de produção usando lotes",
    SelectProductionPlacesUsingFarms: "Selecione os locais de produção usando fazendas",
  
    operatorDeclerationTT: "Declaração de declaração do operador.",
    supplierDeclerationTT: "Declaração de declaração do fornecedor.",

    riskAssessmentNotApproved: "os locais de produção não estão aprovados.",


  

    blockchainVerification: "Verificação de Blockchain",
    scanQrBlockchain: "Escaneie este código QR para visualizar o Relatório de Due Diligence EUDR no blockchain.",
    downloadQrCode: "Baixar código QR",
    eudrPublicReport: "Relatório público de due diligence Dimitra EUDR",
    scanQrEudr: "Digitalize este código QR para visualizar o Relatório de Due Diligence do EUDR na web pública.",
    viewReportForPublic: "Clique aqui para visualizar o relatório público",
    viewReportOnBlockChain: "Clique aqui para visualizar o relatório na blockchain",
    read: "Ler",
    unread: "Não lido",
    declarationMissing: "Declaração Ausente",
    areaForPointGeofence: "Área para Geofence Circular",
    accordingToEUDRFarmsWithLessThan4HectaresDoNotRequireAPolygon: "De acordo com o EUDR, fazendas com menos de 4 hectares não exigem um polígono.",
    circularAreaEquivalent: "Nesses casos, usaremos uma área circular equivalente ao tamanho da fazenda, com o ponto GPS fornecido como centro para verificar o desmatamento. Quando o tamanho da fazenda não for fornecido, usaremos 4 hectares por padrão.",
    ifTheFarmsAreSmallerPleaseEnterTheStandardSizeInTheFieldBelow: "Se as fazendas forem menores, insira o tamanho padrão no campo abaixo.",
    defaultCircularGeofence: "Fazendas sem geofence ou sem informações sobre seu tamanho receberão um geofence circular padrão de 4 hectares. Se o tamanho médio da fazenda for menor que 4 hectares, altere o tamanho padrão clicando no botão 'Editar' abaixo.",
    defaultAreaValueSpecified: "Fazendas sem geofence ou área receberão o valor de área padrão especificado abaixo e serão atribuídas a um geofence circular com um raio circular.",
    uploadFileBeingProcessed: "Seus arquivos carregados estão sendo processados. Você será redirecionado para a página de lista de relatórios de due diligence para ver o status.",
    processingLocations: "Processando Locais",
    lotId: "ID do Lote",
    qualityGade: "Grau de Qualidade",
    importProductionPlaceTT: "Permite aos usuários importar dados do local de produção usando opções de upload ou download de arquivos.",
    removeRiskFarms: "REMOVER FAZENDAS DE RISCO",
    disregardRiskDocument: "DESCONSIDERAR FAZENDAS DE RISCO",
    attachRiskMitigationDocumentForNonCompliantFarms: "ANEXAR DOCUMENTO DE MITIGAÇÃO DE RISCO PARA TODAS AS FAZENDAS NÃO CONFORMES",
    uploadMitigationDocumentForNonCompliantFarms: `Carregar um documento de mitigação de risco para todas as fazendas não conformes mudará o status das fazendas com "Mitigação Necessária" para "Mitigado Manualmente".`,
    disregardFarmWithIssuesTitle: "Desconsiderar Fazenda",
    disregardFarmWithIssuesMessage: "Ao selecionar 'Desconsiderar', o status de avaliação de risco ausente para as fazendas não será considerado neste relatório. As fazendas permanecerão parte do relatório, mas suas avaliações pendentes não afetarão o status de conformidade. Por favor, confirme que deseja continuar.",
    removeRiskFarmTitle: "Remover Fazenda",
    removeRiskFarmMessage: "Ao selecionar 'Remover', as fazendas com avaliações de risco ausentes serão removidas do relatório. Por favor, confirme que deseja continuar.",

    fileName: "Nome do arquivo",
    dateAndTime: "Data e hora",
    downloadProgressStatus: "Status do progresso do download",
    downloadHistory: "Histórico de downloads",
    downloaded: "Baixado",
    inprogress: "Em andamento",
    failed: "Falhou",
    showAllDownloads: "Mostrar todos os downloads",
    inProgress: "Em andamento",
    downloadCompleted: "Download concluído",
    downloadFailed: "Download falhou",
    errorDeletingItem: "Não foi possível excluir o item. Tente novamente mais tarde.",
    anErrorOccuredPlsTryAgain: "Algo deu errado. Por favor, tente novamente.",
    invalidData: "Os dados fornecidos são inválidos. Por favor, verifique e tente novamente.",
    fileIsReady: "O arquivo está pronto para uso",
    invalidFilePathOrUrl: "O caminho ou URL do arquivo é inválido.",
    errorDownloadingFile: "Houve um problema ao baixar o arquivo. Por favor, tente novamente.",
    downloadInitiated: "Download iniciado",
    beingDownloaded: "está sendo baixado agora. Tempo estimado",

    multiStepSurveyDetails: "Com base no número de perguntas em uma etapa, todas as perguntas da pesquisa serão agrupadas e exibidas em etapas. No entanto, esta configuração está disponível apenas antes de adicionar perguntas ou subtítulos. Depois que uma pergunta ou subtítulo for adicionado, a configuração de múltiplas etapas será desativada automaticamente. Por favor, remova quaisquer perguntas ou subtítulos para reativar esta opção.",
    estimatedTime: "Tempo estimado",
    tryAgain: "Tente novamente",

     enableRiskWarnings:"Habilitar avisos de risco"

  },

  diligenceGuide: {
    guide: "Guia",
    downloadPdfManual: "Baixar Manual em PDF",
    watchDemoVideo: "Assistir ao Vídeo de Demonstração",
    viewManualOnWeb: "Ver Manual na Web",
  },

  welcomeScreenDiligenceGuide: {
    title: "Seu Hub Essencial de Guias",
    description: `Explore nossa página de Guias de Ajuda do Sistema de Diligência Devida EUDR
      para recursos essenciais, incluindo manuais em PDF, tutoriais em vídeo e assistência
      baseada na web. Capacite-se para navegar pela plataforma de forma eficiente
      e otimize seu fluxo de trabalho.`,
    continueToTheDueDiligenceSystem: "Continuar para o Sistema de Diligência Devida",
  },
  assessmentStatus:{
    riskAssessmentSummary: "Resumo da Avaliação de Risco",
    riskAssessmentSummaryTT: "Resumo da Avaliação de Risco",
    totalNoOfFarms: "Número Total de Fazendas",
    assessmentsCompleted: "Avaliações Concluídas",
    assessmentsPending: "Avaliações Pendentes",
    requiredMitigation: "Mitigação Necessária",
  }
}